exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".state-success{color:#fff!important;background:#8dc63f!important;border:1px solid #8dc63f!important}.state-error{color:#fff!important;background:#fe4d4f!important;border:1px solid #fe4d4f!important}", ""]);

// exports



// WEBPACK FOOTER //
// ./~/css-loader!./~/sass-loader/lib/loader.js!./~/sass-resources-loader/lib/loader.js?{"resources":["/builds/new-media/admin.lajt-online.pl/platform/src/theme/styles/mixins.sass","/builds/new-media/admin.lajt-online.pl/platform/src/theme/styles/defs/colors.sass"]}!./src/rcapp/components/layout/state/style.sass